import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap"

const ApplicationOwner = props => {
  const [info, setInfo] = useState()

  useEffect(()=>{
    // console.log(props.appDetails)
    if (props.isCompany) {
      setInfo(<CompanyInfo
          appDetails={props.appDetails}
          company={props.company}
        />)

    } else if (props.isIndividual && props.isIndividual == true) {
      setInfo(<IndividualInfo appDetails={props.appDetails} />)
    }  else if (props.isInstitution && props.isInstitution == true) {
      setInfo(<InstitutionInfo appDetails={props.appDetails} />)
    }  else {
      setInfo(<Applicantinfo appDetails={props.appDetails} />)
    }
  },[])
  return (
    <>
      {/* {props.isCompany? (
        <CompanyInfo
          appDetails={props.appDetails}
          company={props.company}
        />
      ) : (
        <Applicantinfo appDetails={props.appDetails} />
      )} */}
      {info}
    </>
  )
}

const Applicantinfo = props => {
  return (
    <>
      <AvForm>
        <CardHeader className="alert alert-success">
          Applicant Information
        </CardHeader>
        <CardBody>
          <div className="accordion-body">
            <Row className="mb-3">
              <Col md={4}>
                <label>First Name</label>
                <input
                  type="text"
                  value={props.appDetails.client.first_name}
                  className="form-control "
                  disabled
                />
              </Col>
              <Col md={4}>
                <label>Last Name</label>
                <input
                  type="text"
                  value={props.appDetails.client.last_name}
                  className="form-control "
                  disabled
                />
              </Col>
              <Col md={4}>
                <label>Other Names</label>
                <input
                  type="text"
                  value={
                    props.appDetails.client.other_name
                      ? props.appDetails.client.other_name
                      : ""
                  }
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Phone</label>
                <input
                  type="text"
                  value={props.appDetails.client.telephone}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Email</label>
                <input
                  type="text"
                  value={props.appDetails.client.email}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>
          </div>
        </CardBody>
      </AvForm>
    </>
  )
}

const CompanyInfo = props => {
  // console.log("Company", props.company)
  return (
    <>
      <AvForm>
        <CardHeader className="alert alert-info">
          Company Information
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="name"
                  label="Company Name"
                  type="text"
                  value={props.company.name}
                  disabled
                />
              </div>
            </Col>

            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="tin"
                  label="Tax Identification Number"
                  type="text"
                  value={props.company.tin}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md="3">
              <div className="mb-3">
                <AvField
                  name="telephone"
                  label="Phone"
                  type="text"
                  disabled
                  value={props.company.telephone}
                />
              </div>
            </Col>
            <Col md="3">
              <div className="mb-3">
                <AvField
                  id="email"
                  name="email"
                  label="Email"
                  className="form-control"
                  disabled
                  value={props.company.email}
                />
              </div>
            </Col>
            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="address"
                  label="Address"
                  className="form-control"
                  value={props.company.address}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <hr></hr>
          <h5>Contact Person Details</h5>
          <Row>
            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="contact_person_name"
                  label="Name"
                  type="text"
                  disabled
                  value={props.company.contact_person_name}
                />
              </div>
            </Col>

            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="contact_person_job_title"
                  label="Job Title"
                  className="form-control"
                  type="text"
                  disabled
                  value={props.company.contact_person_job_title}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="contact_person_phone"
                  label="Phone"
                  type="text"
                  value={props.company.contact_person_phone}
                  disabled
                />
              </div>
            </Col>

            <Col md="6">
              <div className="mb-3">
                <AvField
                  name="contact_person_email"
                  label="Email"
                  className="form-control"
                  type="email"
                  value={props.company.contact_person_email}
                  disabled
                />
              </div>
            </Col>
          </Row>
        </CardBody>
      </AvForm>
    </>
  )
}

const IndividualInfo = props => {
  return (
    <>
      <AvForm>
        <CardHeader className="alert alert-success">
          Applicant Information
        </CardHeader>
        <CardBody>
          <div className="accordion-body">
            <Row className="mb-3">
              <Col md={6}>
                <label>Applicant Name</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.applicant_name}
                  className="form-control "
                  disabled
                />
              </Col>
              <Col md={6}>
                <label>Applicant Type</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.applicant_type}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>TIN</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.tin}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Position</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.applicant_position}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Phone</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.applicant_phone}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Email</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.applicant_phone}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Province</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.province.name}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>District</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.district.name}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Sector</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.sector.name}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Cell</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.cell.name}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>
          </div>
        </CardBody>
      </AvForm>
    </>
  )
}


const InstitutionInfo = props => {
  return (
    <>
      <AvForm>
        <CardHeader className="alert alert-success">
          {props.appDetails.environmental_audit_request.legal_status == "government" ? "Government " : "Private "}
          Institution Details
        </CardHeader>
        <CardBody>
          <div className="accordion-body">
            <Row className="mb-3">
              <Col md={6}>
                <label>Institution Name</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.institution_name}
                  className="form-control "
                  disabled
                />
              </Col>
              <Col md={6}>
                <label>Institution Address</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.institution_address}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Institution Phone</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.institution_phone}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Institution Email</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.institution_email}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Representative Phone</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.representative_phone}
                  className="form-control "
                  disabled
                />
              </Col>

              <Col md={6}>
                <label>Representative Email</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.representative_email}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <label>Contact Person Name</label>
                <input
                  type="text"
                  value={props.appDetails.environmental_audit_request.representative_name}
                  className="form-control "
                  disabled
                />
              </Col>
            </Row>
          </div>
        </CardBody>
      </AvForm>
    </>
  )
}
export default ApplicationOwner
